import { servicesIbsCbs } from '../services';

export const aplicarIbsCbsOuPadrao = async (
  codIbsCbsProduto: number | null,
): Promise<number | null> => {
  if (codIbsCbsProduto && codIbsCbsProduto > 0) return codIbsCbsProduto;

  const ibscbs = await servicesIbsCbs.retornaCodIbsCbsPadrao();
  return ibscbs;
};
